import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import PageBanner from "../layouts/PageBanner";       // <- banner component
import aboutHero from "../../assets/about-hero.jpg";  // <- swap to your image
import About from "../Homepage/About";                // optional: your About section
// import Reasons from "../Homepage/Reasons";          // optional
import Team from "../layouts/Team";
import HeroCTA from "../layouts/HeroCta";
import leftHero from "../../assets/companyimages/img9.jpg";
import bannerImg from "../../assets/companyimages/img3.jpg"; // wide banner
import logo from "../../assets/logoavena.png";
import Ourservices from "../layouts/Ourservices";
import "./Aboutpage.scss";
import Steps from "../layouts/Steps";

// 🔗 Public API base for frontend
const API = "https://api.ainfotech.com.np";

const Aboutpage = () => {
  // ============================
  // CLIENT SECTIONS (FROM API)
  // ============================
  const [clientSections, setClientSections] = useState([]);
  const [loadingClients, setLoadingClients] = useState(true);

  useEffect(() => {
    async function loadClients() {
      try {
        const res = await fetch(`${API}/api/clients/sections`);
        const data = await res.json();
        setClientSections(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Failed to load client sections", err);
      } finally {
        setLoadingClients(false);
      }
    }
    loadClients();
  }, []);

  // helper to render a single row (alternating layout on desktop only)
  const renderClientRow = (section, index) => {
    const logos = Array.isArray(section.logos)
      ? section.logos.filter((l) => l.image)
      : [];

    if (logos.length === 0) return null; // skip empty ones

    const isAlt = index % 2 === 1; // odd index → alternate on desktop
    const marqueeDirection = isAlt ? "right" : "left";

    // shared logo nodes
    const logoNodes = logos.map((logoItem, idx) => (
      <div className="clients-logo" key={`${section.id}-${idx}`}>
        <div className="client-logo-wrapper">
          <img
            src={`${API}${logoItem.image}`}
            alt="Client logo"
            loading="lazy"
          />
        </div>
      </div>
    ));

    // ✅ If 5 or more logos → marquee; else → static centered logos
    const logosView =
      logos.length >= 5 ? (
        <Marquee
          speed={40}
          gradient={false}
          pauseOnHover={true}
          direction={marqueeDirection}
        >
          {logoNodes}
        </Marquee>
      ) : (
        <div className="clients-static-logos">{logoNodes}</div>
      );

    const categoryBlock = (
      <div className="clients-row__category">
        <h3 className="clients-row__name">{section.name}</h3>
        {section.description && (
          <p className="clients-row__desc">{section.description}</p>
        )}
      </div>
    );

    return (
      <div className="row g-4 align-items-center clients-row" key={section.id}>
        {/* 
          On MOBILE:
            - order-* does NOT apply → category first, logos below (same for all rows)
          On DESKTOP (lg and up):
            - even rows: category left, logos right
            - odd rows:  logos left, category right
        */}
        <div
          className={`col-12 col-lg-4 ${
            isAlt ? "order-lg-2" : "order-lg-1"
          }`}
        >
          {categoryBlock}
        </div>

        <div
          className={`col-12 col-lg-8 ${
            isAlt ? "order-lg-1" : "order-lg-2"
          }`}
        >
          <div
            className={
              "clients-row__logos " +
              (marqueeDirection === "left"
                ? "marquee-center-left"
                : "marquee-center-right")
            }
          >
            {logosView}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <PageBanner
        title="About Us"
        bg={aboutHero}
        crumbs={[
          { label: "Home", href: "/" },
          { label: "About Us" },
        ]}
      />

      <main className="avena-aboutpage">
        {/* ===================== INTRO SECTION ===================== */}
        <section className="avena-aboutIntro">
          <div className="container">
            <div className="row g-5 align-items-start avena-aboutIntro__row">
              {/* LEFT: Large image */}
              <div className="col-12 col-lg-5">
                <figure className="aboutIntro-left">
                  <img src={leftHero} alt="Avena team at work" loading="lazy" />
                </figure>
              </div>

              {/* RIGHT: Content column */}
              <div className="col-12 col-lg-7">
                <div className="aboutIntro-right">
                  {/* Small badge */}
                  <div className="aboutIntro-badge">
                    <img
                      className="aboutIntro-badge__logo"
                      src={logo}
                      alt=""
                    />
                    <span>About our company</span>
                  </div>

                  {/* Big headline */}
                  <h2 className="aboutIntro-title">
                    Trusted Partner in
                    <br />
                    Construction and Design
                  </h2>

                  {/* Wide banner with overlay text */}
                  <div className="aboutIntro-banner">
                    <img
                      src={bannerImg}
                      alt="Project banner"
                      loading="lazy"
                    />
                    <div className="aboutIntro-banner__text">
                      <div className="aboutIntro-banner__kicker">
                        Building Trust
                      </div>
                      <div className="aboutIntro-banner__title">
                        Since 2025
                      </div>
                    </div>
                  </div>

                  <p className="aboutIntro-copy">
                    Our journey began with a commitment to excellence, and that
                    commitment remains at the core of our operations today.
                    We’ve grown from a small local business into a trusted
                    partner for both residential and commercial projects—
                    delivering secure IT, reliable infrastructure, and modern
                    software solutions.
                    <br />
                    <br />
                    Over the years, our team has expanded with passionate
                    engineers, designers, and consultants who share one goal:
                    to simplify technology and make it truly work for people.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===================== OUR CLIENTS (DYNAMIC) ===================== */}
        {/* <section className="avena-clients">
          <div className="container">
            
            <div className="avena-clients__head text-center">
              <span className="avena-clients__eyebrow">OUR CLIENTS</span>
              <h2 className="avena-clients__title">
                Trusted Across Multiple <span>Industries</span>
              </h2>
              <p className="avena-clients__sub">
                We proudly work with businesses across IT, construction,
                hospitality and more.
              </p>
            </div>

           
            {loadingClients ? (
              <div className="text-center py-4">Loading clients…</div>
            ) : clientSections.length === 0 ? (
              <div className="text-center py-4">
                Client logos will appear here once added.
              </div>
            ) : (
              clientSections.slice(0, 6).map((section, index) =>
                renderClientRow(section, index)
              )
            )}
          </div>
        </section> */}

        <Steps />
      </main>

      <Team />
      <HeroCTA />
    </>
  );
};

export default Aboutpage;
